import React from 'react';

import webinarBanner from 'assets/images/webinar-buy-reliability-build-intelligence@2x.png';
import { Button } from 'components/Button';
import { useCountdown } from './useCountdown';

export const WEBINAR_START_AT = '2026-09-23T16:00:00.000Z';

const HUBSPOT_HREF =
  'https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLL%2FOZalDEIJjM6hnYak0HPAeSuV5gAmW7Sorv0%2Bt9e9ejD%2FHc9rLug7W4%2BMsy%2BjYGNXnbSJki%2F4%2FGpPjvBg3nzsrjKhbZt4YVuQQi%2BLwYLj5Q%2B8S1iE7gQN63nYqSuuG5sNzDoLBwt3X0uTWzIBxgQ67AxE9xyKLqMW2xF5QoAprrz3PUTR%2B0q13DC2kL94fITBGdJfKQkejgq56cWQjpUdTOl93K4t2EA%3D&webInteractiveContentId=220187818249&portalId=6840215';

interface CountdownCellProps {
  value: number;
  label: string;
}

function CountdownCell({ value, label }: CountdownCellProps) {
  return (
    <div className="flex flex-col items-center">
      <span className="text-3xl font-bold text-white tabular-nums leading-none">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-xs text-[#A1B3C1] uppercase tracking-widest mt-1">{label}</span>
    </div>
  );
}

export default function WebinarPromo() {
  const countdown = useCountdown(WEBINAR_START_AT);

  return (
    <div className="flex flex-col items-center justify-center w-full h-full bg-brandDarkest p-8 gap-6">
      <img
        src={webinarBanner}
        alt="Buy reliability, build intelligence webinar featuring Bernadette Nabil and Ian Williams"
        className="w-full max-w-[601px] mx-auto block"
        style={{ aspectRatio: '601/450' }}
      />

      <p className="text-white text-center text-sm max-w-[480px] leading-relaxed">
        A blueprint for high-velocity data infrastructure: How engineering teams stop firefighting
        scrapers and start building the intelligence layer that actually differentiates them.
      </p>

      <Button
        text="REGISTER NOW"
        href={HUBSPOT_HREF}
        className="button button-secondary !bg-white !text-brandDarkest hover:!bg-white/90 focus:!ring-offset-brandDarkest"
      />

      <p className="text-[#A1B3C1] text-sm text-center">
        ScraperAPI LIVE Webinar Series · September 23, 2026
      </p>

      <div className="flex items-center gap-8">
        <CountdownCell value={countdown.days} label="Days" />
        <CountdownCell value={countdown.hours} label="Hours" />
        <CountdownCell value={countdown.minutes} label="Minutes" />
        <CountdownCell value={countdown.seconds} label="Seconds" />
      </div>
    </div>
  );
}
